import React from "react"

import DesktopMenu from "./deskTopMenu"
import MobileMenu from "./mobileMenu"

import './menu.css'

import logo from '../../images/logo.png'

const MenuList = [
    [
        'Home', // title
        '/', // Link
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Features',
        '/#features', 
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Stake',
        '/#stake',
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Community',
        '/#community',
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Enter App',
        '/dashboard',
        'Global---menu-nav-btn px-4 py-2 mx-1', // Class for Desktop
        'Global---menu-nav-btn text-center px-3 py-2 mx-3 mb-2' // Class for Mobile
    ]
];
const Menu = () => {
    return(
        <div style={{borderBottom: '1px solid #1D1D1D'}}>
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        </div>
    )
}

export default Menu;